import EventHubMixin from '@/mixins/EventHub.js'
import SizesMixin from '@/mixins/Sizes.js'

import AppPicture from '@/components/app-picture'

export default
{
    name: 'app-gallery-widget',

    mixins:
    [
        EventHubMixin,
        SizesMixin
    ],

    components:
    {
        AppPicture
    },

    props:
    {
        content: { type: Object, default()
        {
            return {}
        } },
        text: { type: String, default: '' }
    },

    data()
    {
        return {
            visibleCount: 0
        }
    },

    created()
    {
        this.currentSize = null

        this.chunkPerSize = {
            0: 6,
            768: 9,
            1024: 12,
            1200: 15,
            1600: 21
        }

        this.chunkCount = 0
    },

    mounted()
    {
        this.onResize()
    },

    methods:
    {
        onImageClick(index)
        {
            this.$eventHub.$emit('gallery.activate', this.content.ID, index)
        },

        onBottomClick()
        {
            if(this.content.images.length - this.visibleCount - this.chunkCount < this.chunkCount)
            {
                this.visibleCount = this.content.images.length
            }
            else
            {
                this.visibleCount += this.chunkCount
            }
        },

        onResize()
        {
            // Find current size
            let currentSize = 0

            for(const _sizeKey in this.chunkPerSize)
            {
                if(this.sizes.width >= _sizeKey)
                {
                    currentSize = _sizeKey
                }
            }

            // Current size changed
            if(currentSize !== this.currentSize)
            {
                this.currentSize = currentSize
                this.chunkCount = this.chunkPerSize[this.currentSize]
                this.visibleCount = this.chunkCount
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-gallery-widget/script.js